// import { faFacebook, faGoogle } from "@fortawesome/free-brands-svg-icons";
import {
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
//import Logo from "../../../images/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SocialLogin from "../SocialLogin/SocialLogin";
import { useTranslation } from "react-i18next";
import { legalDisclaimerApi, login, sendotp } from "../../../api/user";
import {
  setPendingSignupEmail,
  setVerificationToken,
} from "../../../utils/pendingSignup";
import { toast } from "react-toastify";
import PageContainer from "../../../components/pages/PageContainer";
import ProcessingButton from "../../../components/Skeleton/ProcessingButton";
import { event } from "../../../utils/event";
import LegalPopupModal from "../../../components/Modals/legalDisclaimer";
import { setSidebarCollapseOverride } from "../../../utils/sidebarCollapse";
import qushiLogo from "../../../images/logo-green.png";
import useAuthScreenBackground from "../../../hooks/useAuthScreenBackground";

// Maps the backend's existing resend-code responses (lang/en/message.php) to
// display copy. OTP_RESEND carries its countdown as "1 minutes 30 seconds".
function resendCodeMessage(message, fallback = message) {
  if (message === "Please wait a moment before requesting another code.") {
    return "Wait before requesting another code.";
  }
  const wait =
    typeof message === "string" &&
    message.match(/^Please try again after (.+) to resend the verification code\.$/);
  if (wait) {
    const part = (unit) => Number(wait[1].match(new RegExp(`(\\d+) ${unit}`))?.[1] || 0);
    const seconds = part("hours") * 3600 + part("minutes") * 60 + part("seconds");
    return `Try again in ${seconds}s.`;
  }
  if (message === "We could not read the email for this request. Please start again.") {
    return "We could not find the email for this request. Start again.";
  }
  if (message === "We could not find an account for that email address.") {
    return "We could not find an account for that email.";
  }
  return fallback;
}

const loginErrorMessage = (message) =>
  message === "Invalid login credentials."
    ? "Email or password is incorrect."
    : message;

const QushiLogo = () => (
  <img src={qushiLogo} alt="QUSHi" style={{ width: "120px" }} />
);

function LoginIndex() {
  //const { t, i18n } = useTranslation();
  const { t } = useTranslation();
  // Cream all the way to the screen edges - see the hook for why the wrapper
  // div alone could not reach behind the status bar and home indicator.
  useAuthScreenBackground();
  const navigate = useNavigate();
  // A one-off confirmation handed over by another screen - currently the
  // password reset, which finishes here rather than on its own screen. Kept as
  // navigation state (not a toast) so it is still on screen while the user
  // types their new password in.
  const routeNotice = useLocation().state?.notice;
  const [error, setError] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPopup, setShowPopUp] = useState(false);
  const [checked, setChecked] = useState(false);
  const [isMobileView] = useState(window.innerWidth < 768);

  const handleCheckboxChange1 = () => {
    setChecked(!checked);
  };

  const handleClose = () => {
    navigate("/profile");
    localStorage.setItem("checkDisclaimer", false);
    return setShowPopUp(false);
  };

  const handleLegalPopup = async () => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    try {
      const res = await legalDisclaimerApi(checked);
      if (res?.data?.status === 200) {
        setShowPopUp(false);
        if (userInfo?.user_name) {
          navigate("/profile");
        } else {
          navigate("/edit-profile");
        }
        localStorage.setItem("checkDisclaimer", false);
      }
    } catch (err) {}
  };

  useEffect(() => {
    event("sendDataToReactApp");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic email validation
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setError({ email: ["Invalid email address"] });
      return;
    }

    // Password validation
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*[a-z]).{8,}$/;
    if (!password || !passwordRegex.test(password)) {
      setError({
        password: [
          'Password must be at least 8 characters and include one capital letter and one special character (!@#$%^&*(),.?":{}|<>)',
        ],
      });
      return;
    }

    setError(null);
    setLoading(true);

    const body = {
      username: email,
      password: password,
    };

    try {
      const response = await login(body);
      if (response?.data?.status === 200) {
        // Resume a half-finished signup instead of dropping the user into the
        // app. An account can exist with the email still unverified, or with
        // verification done but the profile never filled in - signing in should
        // pick up at whichever step is outstanding rather than looking like a
        // second registration is needed.
        const signedInUser = response.data.data;
        const otpVerified = JSON.parse(signedInUser?.is_otp_verified ?? false);
        const profileIncomplete = !signedInUser?.user_name;

        if (response?.data?.data?.disclaimer === false) {
          setShowPopUp(true);
        } else if (!otpVerified) {
          // Left to the unverified branch below, which requests a fresh code
          // and lands on /auth/verification.
        } else {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "login", method: "email" });
  // Retrieve gameurl from local storage
  let savedUrl = JSON.parse(localStorage.getItem("gameurl"));

   const redirectUrl = localStorage.getItem("redirectUrl") || "/profile";
    localStorage.removeItem("redirectUrl");

  // Replace "contests" with "contest" in the saved URL if it exists
  if (savedUrl && savedUrl.includes("/contests/")) {
    savedUrl = savedUrl.replace("/contests/", "/contest/");
  }

  // Land in the app after sign-in. Use a full navigation (same as before) so
  // we leave exactly one app entry in history — never "/" (the old StartScreen
  // landing) — so a single Back press returns to this "Welcome back" screen.
  // A full load here also supersedes the deferred navigate("/profile") below,
  // preventing a duplicate /profile entry that would swallow the first Back.
  if (savedUrl) {
    window.location.href = savedUrl;
  } else {
    window.location.href = profileIncomplete ? "/edit-profile" : redirectUrl;
  }
}
        const accessToken = response.data.data.access_token;
        localStorage.setItem("accessToken", JSON.stringify(accessToken));
        setSidebarCollapseOverride(null);
        localStorage.setItem(
          "messageCount",
          response?.data?.data?.message_count
        );
        localStorage.setItem("notificationCount", response?.data?.data?.badge);
        // Sync notification badge in header immediately on login
        window.dispatchEvent(
          new CustomEvent("myCustomEvent", {
            detail: {
              messageCount: response?.data?.data?.message_count || 0,
              notificationCount: response?.data?.data?.badge || 0,
            },
          })
        );
        setPendingSignupEmail(response.data.data.email);
        localStorage.setItem("userInfo", JSON.stringify(response.data.data));
        localStorage.setItem("isVerified", response.data.data?.is_otp_verified);
        localStorage.setItem("img", response.data.data.image);
        localStorage.setItem("user_id", response.data.data.id);
        const email = { email: response.data.data.email, otp_purpose: 2 };
        const is_otp_verified = JSON.parse(response.data.data?.is_otp_verified);
        if (!is_otp_verified) {
          const res = await sendotp(email);
          if (res) {
            if (res.data.status === 400) {
              toast.error(resendCodeMessage(res.data.message));
            } else {
              toast.success("Verification code sent to your email.");
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ event: "email_verification_sent", method: "email" });
            }
            // Only a successful send returns a token. Reading it unconditionally
            // threw on the 400 branch (the resend cooldown), which is how users
            // reached the verification screen with no token at all and then hit
            // "The token field is required." on submit.
            setVerificationToken(res.data.data?.email_token);
          }
          setLoading(false);
          navigate("/auth/verification");
        } else {
          setLoading(false);
          if (response?.data?.data?.disclaimer === false) {
            setShowPopUp(true);
          } else {
            setTimeout(() => {
              navigate(profileIncomplete ? "/edit-profile" : "/profile");
            }, 2000);
          }
        }
      }
      setLoading(false);
      if (response?.data?.status === 400) {
        toast.error(loginErrorMessage(response.data.message));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(loginErrorMessage(error.response.data.message));
      }
    }
  };

  if (isMobileView) {
    return (
      <PageContainer>
        <div className="min-h-screen w-full flex flex-col px-8 pt-12 pb-8" style={{ backgroundColor: "#F2F0EC" }}>
          <div className="flex-1 flex flex-col justify-center items-center">
            <h1 className="text-primaryColor font-extrabold text-4xl mb-10 font-montserrat">
              Welcome back
            </h1>
            {routeNotice ? (
              <p
                role="status"
                className="text-primaryColor text-sm font-semibold text-center mb-6 font-montserrat"
              >
                {routeNotice}
              </p>
            ) : null}
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <input
                  id="email"
                  type="text"
                  name="email"
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t("Email")}
                  className="w-full rounded-full bg-gray-200 placeholder-gray-500 text-gray-700 px-5 py-4 focus:outline-none"
                />
                {error?.email && (
                  <span className="block text-red-500 text-xs mt-1 ml-2">
                    {error.email[0]}
                  </span>
                )}
              </div>
              <div className="mb-2">
                <div className="relative">
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder={t("Password")}
                    className="w-full rounded-full bg-gray-200 placeholder-gray-500 text-gray-700 px-5 py-4 pr-12 focus:outline-none"
                  />
                  <div
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </div>
                </div>
                {error?.password && (
                  <span className="block text-red-500 text-xs mt-1 ml-2">
                    {error.password[0]}
                  </span>
                )}
              </div>
              <div className="flex justify-end mb-3">
                <Link
                  to="/auth/forgot-password"
                  className="text-primaryColor text-sm font-semibold font-montserrat"
                >
                  {t("forgot_your_password")}?
                </Link>
              </div>
              {/* Inline only — the full-screen sign-in overlay is gone. Same
                  fill while busy; input blocked so credentials can't be posted
                  twice. */}
              <ProcessingButton
                processing={loading}
                type="submit"
                label={t("sign_in")}
                processingLabel={t("signing_in")}
                className="w-full bg-primaryColor text-white rounded-2xl py-4 font-bold text-lg focus:outline-none active:opacity-80 transition"
              />
            </form>
            <div className="onboarding-social mt-4">
              <SocialLogin />
            </div>
            {/* Registration temporarily disabled. Restore this block to re-enable email sign-up. */}
            <div className="text-center mt-6">
              <span className="text-gray-600 font-montserrat">{t("new_user")}? </span>
              <Link to="/auth/create-account" className="text-primaryColor font-bold underline font-montserrat">
                {t("create_account")}
              </Link>
            </div>
          </div>
          <div className="flex justify-center py-6">
            <QushiLogo />
          </div>
        </div>
        <LegalPopupModal
          isOpen={showPopup}
          handleLegalPopup={handleLegalPopup}
          checked={checked}
          handleClose={handleClose}
          handleCheckboxChange1={handleCheckboxChange1}
        />
      </PageContainer>
    );
  }

  /* ── Desktop layout ── */
  return (
    <>
      <PageContainer>
        <div className="flex min-h-screen">
          {/* Left: dark teal branding panel */}
          <div className="w-1/2 bg-primaryColor flex flex-col items-center justify-center">
            {/* Brand lockup. The tagline must sit SLIGHTLY NARROWER than the
                QUSHi wordmark — never match or overhang it. At w-64 the mark
                renders ~250px of ink; 14px / 0.3em tracking puts the tagline at
                ~234px (~94%). The negative right margin cancels the trailing
                letter-space so the line optically centres under the mark.
                Changing the copy means re-checking the width. */}
            <img src="/Logo.png" alt="QUSHi" className="w-64" />
            <p
              className="text-white text-sm mt-4 uppercase whitespace-nowrap"
              style={{ letterSpacing: "0.3em", marginRight: "-0.3em" }}
            >
              TRADE TRACK PROVE IT
            </p>
          </div>

          {/* Right: cream form panel */}
          <div className="w-1/2 flex items-center justify-center px-12 py-12 min-h-screen" style={{ backgroundColor: "#F2F0EC" }}>
            <div className="w-full max-w-sm">
              <h1 className="text-primaryColor font-extrabold text-4xl mb-10 font-montserrat">
                Welcome back
              </h1>
              {routeNotice ? (
                <p
                  role="status"
                  className="text-primaryColor text-sm font-semibold text-center mb-6 font-montserrat"
                >
                  {routeNotice}
                </p>
              ) : null}
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <input
                    id="email"
                    type="text"
                    name="email"
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={t("Email")}
                    className="w-full rounded-full bg-gray-200 placeholder-gray-500 text-gray-700 px-5 py-4 focus:outline-none"
                  />
                  {error?.email && (
                    <span className="block text-red-500 text-xs mt-1 ml-2">
                      {error.email[0]}
                    </span>
                  )}
                </div>
                <div className="mb-2">
                  <div className="relative">
                    <input
                      id="password"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder={t("Password")}
                      className="w-full rounded-full bg-gray-200 placeholder-gray-500 text-gray-700 px-5 py-4 pr-12 focus:outline-none"
                    />
                    <div
                      className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 cursor-pointer"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                    </div>
                  </div>
                  {error?.password && (
                    <span className="block text-red-500 text-xs mt-1 ml-2">
                      {error.password[0]}
                    </span>
                  )}
                </div>
                <div className="flex justify-end mb-4">
                  <Link
                    to="/auth/forgot-password"
                    className="text-primaryColor text-sm font-semibold font-montserrat"
                  >
                    {t("forgot_your_password")}?
                  </Link>
                </div>
                <ProcessingButton
                  processing={loading}
                  type="submit"
                  label={t("sign_in")}
                  processingLabel={t("signing_in")}
                  className="w-full bg-primaryColor text-white rounded-2xl py-4 font-bold text-lg focus:outline-none active:opacity-80 transition"
                />
              </form>
              <SocialLogin />
              {/* Registration temporarily disabled. Restore this block to re-enable email sign-up. */}
              <div className="text-center mt-6">
                <span className="text-gray-600 font-montserrat">{t("new_user")}? </span>
                <Link to="/auth/create-account" className="text-primaryColor font-bold underline font-montserrat">
                  {t("create_account")}
                </Link>
              </div>
              <div className="flex justify-center mt-10">
                <QushiLogo />
              </div>
            </div>
          </div>
        </div>

        <LegalPopupModal
          isOpen={showPopup}
          handleLegalPopup={handleLegalPopup}
          checked={checked}
          handleClose={handleClose}
          handleCheckboxChange1={handleCheckboxChange1}
        />
      </PageContainer>
    </>
  );
}

export default LoginIndex;
